import type { paymentsApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSService } from "../../../../utils/WSService";

const service = new WSService("/v2/payments/payables");

export const createPayableBulkAction = async (
  body: paymentsApiSpec.CreatePayableBulkActionRequest
): Promise<paymentsApiSpec.PayableBulkActionBatch> => {
  const { data } = await service.post("/bulk-action", body);
  return data as paymentsApiSpec.PayableBulkActionBatch;
};
